import { platforms } from '@bingads-webui-campaign-react/app-store-selector';
import { FLOWS } from '@bingads-webui-campaign-react/unified-app-shared';

import {
  UAPPlacementTypeAlias as EPT,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

export const flowToPlatform = {
  [FLOWS.IOS]: platforms.IOS,
  [FLOWS.ANDROID]: platforms.ANDROID,
  [FLOWS.WINDOWS]: platforms.WINDOWS,
};

export const unifiedAppAdsSurfaces = {
  VideoGaming: {
    key: 'VideoGaming',
    title: _TL_('Video Gaming'),
    placements: [
      'VideoHorizontal',
    ],
  },
  M365: {
    key: 'M365',
    title: _TL_('M365'),
    placements: [
      'M365Outlook',
    ],
  },
  MsnDisplay: {
    key: 'MsnDisplay',
    title: _TL_('MSN & Display'),
    placements: [
      'MSNDisplay',
    ],
  },
  MicrosoftCasualGames: {
    key: 'MicrosoftCasualGames',
    title: _TL_('Microsoft Casual Games'),
    placements: [
      'CasualGamesDimensions',
    ],
  },
  BingSearch: {
    key: 'BingSearch',
    title: _TL_('Bing Search'),
    placements: [
      'BingSearch',
      'BingSearchText',
    ],
  },
};

export const adPreviewConfig = [{
  placementSetName: unifiedAppAdsSurfaces.VideoGaming.key,
  placementTypes: [
    EPT.UnifiedAppAds.VideoHorizontal,
  ],
}, {
  placementSetName: unifiedAppAdsSurfaces.M365.key,
  placementTypes: [
    EPT.UnifiedAppAds.M365Outlook,
  ],
}, {
  placementSetName: unifiedAppAdsSurfaces.MsnDisplay.key,
  placementTypes: [
    EPT.UnifiedAppAds.MSNDisplay,
  ],
}, {
  placementSetName: unifiedAppAdsSurfaces.MicrosoftCasualGames.key,
  placementTypes: [
    EPT.UnifiedAppAds.CasualGamesDimensions,
  ],
}, {
  placementSetName: unifiedAppAdsSurfaces.BingSearch.key,
  placementTypes: [
    EPT.UnifiedAppAds.BingSearch,
    EPT.UnifiedAppAds.BingSearchText,
  ],
}];

